export const authHeader = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user && user.token) {
    return {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST,GET,PUT,DELETE",
      "Access-Control-Allow-Headers": "Content-Type",
      Authorization: "Bearer " + user.token
    };
  } else {
    return null;
  }
};

export const authHeaderMultiPart = form => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user && user.token) {
    return {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST,GET,PUT,DELETE",
      "Access-Control-Allow-Headers": "Content-Type",
      Authorization: "Bearer " + user.token
    };
  } else {
    return null;
  }
};
